import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { getMeterSizeById } from '@/lib/api/meter'
import { MeterSizeForm } from '@/components/forms/meter-size-form'
import { Header } from '@/components/header'

export const Route = createFileRoute(
  '/_home/meter-connection-settings/meter-size/edit/$id',
)({
  loader: async ({ params: { id } }) => {
    return { id }
  },
  component: () => <EditMeterSizePage />,
})

function EditMeterSizePage() {
  const { id } = Route.useLoaderData()
  const meterSizeId = Number(id)
  const { data, isError, isLoading } = useQuery({
    queryKey: ['meterSizeById'],
    queryFn: () => getMeterSizeById(meterSizeId),
  })

  return <main className="space-y-3 p-4"></main>
}
